import { Routes } from '@angular/router';
import { DynamicTemplateComponent } from './components/dynamic-template/dynamic-template.component';
import { TemplateGeneratorComponent } from './components/template-generator/template-generator.component';
import { TemplateresolverService } from './services/templateresolver/templateresolver.service';
import { AuthGuard } from './guards/auth.guard';
import { RoleGuard } from './guards/role.guard';
import { LogoutComponent } from './components/logout/logout.component';
import { PortalRedirectGuard } from './guards/portal-redirect.guard';
import { MediaPreviewComponent } from './components/media-preview/media-preview.component';

export const routes: Routes = [
  { 
    path: '', 
    component: DynamicTemplateComponent,
    canActivate: [PortalRedirectGuard],
    resolve: { data: TemplateresolverService }
  },
  { 
    path: 'template-generator', 
    component: TemplateGeneratorComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { role: 'superadmin' }
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: 'media/:obfuscatedName',
    component: MediaPreviewComponent
  },
  { 
    path: '**', 
    component: DynamicTemplateComponent,
    resolve: { data: TemplateresolverService }
  }
];
